import {
  addCategory,
  renameCategory,
  getCategory,
  deleteCategoryByID,
  getAllProducts,
  moveProductToCategory,
  deleteProductByID,
  rebuildCategoryCache,
} from "../../../api/divvy-categories";

const categories = {
  namespaced: true,
  state: () => ({
    pageNumber: 1,
    headingLabel: "",
    addCategoryData: null,
    renameCategoryData: null,
    getCategoryData: null,
    getCategoryResults: null,
    currentCategoryID: 1,
    currentCategoryHID: "/",
    getAllProductsData: null,
    productSearchTerm: "",
    renameCategoryHID: "/",
    sidepanelFetching: false,
    mainpanelFetching: false,
  }),
  getters: {
    getAddCategoryData: (state) => {
      return state.addCategoryData;
    },
    getRenameCategoryData: (state) => {
      return state.renameCategoryData;
    },
    getCategoryData: (state) => {
      return state.getCategoryData;
    },
    getCategoryResults: (state) => {
      return state.getCategoryResults;
    },
    getCurrentCategoryID: (state) => {
      return state.currentCategoryID;
    },
    getCurrentCategoryHID: (state) => {
      return state.currentCategoryHID;
    },
    getAllProductsData: (state) => {
      return state.getAllProductsData;
    },
    getSearchProductTerm: (state) => {
      return state.productSearchTerm;
    },
    getRenameCategoryHID: (state) => {
      return state.renameCategoryHID;
    },
    sidepanelFetchingState: (state) => {
      return state.sidepanelFetching;
    },
  },
  actions: {
    addCategory({ commit }, payload) {
      return new Promise((resolve, reject) => {
        addCategory(payload)
          .then((data) => {
            resolve(data);
            commit("SET_ADD_CATEGORY_DATA", data);
          })
          .catch((err) => {
            console.log("error in addCategory store", err);
          });
      });
    },
    renameCategory({ commit }, payload) {
      return new Promise((resolve, reject) => {
        renameCategory(payload)
          .then((data) => {
            resolve(data);
            commit("SET_RENAME_CATEGORY_DATA", data);
          })
          .catch((err) => {
            console.log("error in renameCategory store", err);
          });
      });
    },
    getCategory({ commit }, params) {
      return new Promise((resolve, reject) => {
        getCategory(params)
          .then((data) => {
            resolve(data);
            commit("SET_GET_CATEGORY_DATA", data);
            commit("SET_GET_CATEGORY_RESULTS", data);
          })
          .catch((err) => {
            console.log("error in getCategory store", err);
          });
      });
    },
    deleteCategoryByID({ commit }, params) {
      return new Promise((resolve, reject) => {
        deleteCategoryByID(params)
          .then((data) => {
            resolve(data);
          })
          .catch((err) => {
            console.log("error in deleteCategoryByID store", err);
          });
      });
    },
    getAllProducts({ commit }, payload) {
      return new Promise((resolve, reject) => {
        getAllProducts(payload)
          .then((data) => {
            resolve(data);
            commit("SET_ALL_PRODUCTS_DATA", data);
          })
          .catch((err) => {
            console.log("error in getAllProducts store", err);
          });
      });
    },
    moveProductToCategory({ commit }, payload) {
      return new Promise((resolve, reject) => {
        moveProductToCategory(payload)
          .then((data) => {
            resolve(data);
          })
          .catch((err) => {
            console.log("error in moveProductToCategory store", err);
          });
      });
    },
    deleteProductByID({ commit }, params) {
      return new Promise((resolve, reject) => {
        deleteProductByID(params)
          .then((data) => {
            resolve(data);
          })
          .catch((err) => {
            console.log("error in deleteProductByID store", err);
          });
      });
    },
    rebuildCategoryCache({ commit }, params) {
      return new Promise((resolve, reject) => {
        rebuildCategoryCache(params)
          .then((data) => {
            resolve(data);
          })
          .catch((err) => {
            console.log("error in rebuildCategoryCache store", err);
          });
      });
    },
  },
  mutations: {
    SET_ADD_CATEGORY_DATA: (state, data) => {
      state.addCategoryData = data;
    },
    SET_RENAME_CATEGORY_DATA: (state, data) => {
      state.renameCategoryData = data;
    },
    SET_GET_CATEGORY_DATA: (state, data) => {
      state.getCategoryData = data;
    },
    SET_GET_CATEGORY_RESULTS: (state, data) => {
      state.getCategoryResults = data.categories.filter((Category) => {
        return Category.categoryID !== null;
      });
    },
    SET_CURRENT_CATEGORY_ID: (state, data) => {
      state.currentCategoryID = data;
    },
    SET_CURRENT_CATEGORY_HID: (state, data) => {
      state.currentCategoryHID = data;
    },
    SET_ALL_PRODUCTS_DATA: (state, data) => {
      data.Result?.map((product) => {
        // validation function
        let isValidURL = (str) => {
          let url;

          try {
            url = new URL(str);
          } catch (_) {
            return false;
          }

          return url.protocol === "http:" || url.protocol === "https:";
        };

        // change image url if not valid
        if (!isValidURL(product.productsParent.imageurl)) {
          product.productsParent.imageurl = `https://talkingmart_static.incentiveweb.dev/products/${product.productsParent.imageurl}`;
        }
      });

      state.getAllProductsData = data;
    },
    SET_PRODUCT_SEARCH_TERM: (state, data) => {
      state.productSearchTerm = data;
    },
    SET_RENAME_CATEGORY_HID: (state, data) => {
      state.renameCategoryHID = data;
    },
    SET_SIDEPANEL_FETCHING_STATE: (state, data) => {
      state.sidepanelFetching = data;
    },
    SET_MAINPANEL_FETCHING_STATE: (state, data) => {
      state.mainpanelFetching = data;
    },
    SET_PAGE_NUMBER: (state, data) => {
      state.pageNumber = data;
    },
    SET_HEADING_LABEL: (state, data) => {
      state.headingLabel = data;
    },
  },
};

export default categories;
